import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { ToastContainer, toast } from "react-toastify";
import ADMIN_ROLES from "data/admin-roles";
import ModalContainer from "views/lib/components/modals";
import AlertWrapper from "views/lib/components/alertWrapper";

import LocationsRouter from "routers/locations-router";

import Header from "views/layout/header";
import Sidebar from "views/layout/sidebar";
import NotFound from "views/pages/not-found";
import PermissionError from "views/pages/permission-error";
import Login from "views/pages/login";
import Dashboard from "views/pages/dashboard/index";
import Users from "views/pages/users";
import Wallet from "views/pages/wallet";
import Transaction from "views/pages/transaction";

// import WalletSignle from "views/pages/wallet";
import UserProfile from "views/pages/users/user-profile";
import Bikes from "views/pages/bikes";
import BikesScanTrigger from "views/pages/bikes-scan-trigger";
import BikesTriggerHistory from "views/pages/bikes-trigger-history";
import BikeSingle from "views/pages/bikes/bike-single";
import BikesHistory from "views/pages/bikes-history";
import BikesHotMap from "views/pages/bikes/bikes-hot-map";
import BikesPolice from "views/pages/bikes/bikes-police";
import Tariff from "views/pages/tariff/list";
import Package from "views/pages/package/list";
import Tag from "views/pages/tag/index";
import Alerts from "views/pages/bikes/alerts";
import Zoning from "views/pages/zoning/index";
import FestiveDays from "views/pages/festiveDays";
import Fee from "views/pages/fee";
import TopUsers from "views/pages/top-users";
import Settings from "views/pages/settings";
// import Reports from "views/pages/reports";
import ReportsDailyRange from "views/pages/reports/daily-range";
import NotificationTemplates from "views/pages/notificationTemplates";
import PhoneCodes from "views/pages/phone-codes";
import News from "views/pages/news";
import Stories from "views/pages/stories";
import StoriesSingle from "views/pages/stories/single";
import StaticPages from "views/pages/static-pages";
import StaticPagesEdit from "views/pages/static-pages/StaticPagesEdit";
import PromoCodes from "views/pages/promo-codes";
import TripActive from "views/pages/trip-active";

import Scooters from "views/pages/scooter/scooter";
import ScootersSingle from "views/pages/scooter/scooter/single";
import ScooterHotMap from "views/pages/scooter/scooter/hot-map";
import ScooterHistory from "views/pages/scooter/history";
import ScootersBattery from "views/pages/scooter/battery";
import ScootersBatteryHistory from "views/pages/scooter/battery-history";
import ScooterTripActive from "views/pages/scooter/trip-active";
import ScooterTripActiveView from "views/pages/scooter/trip-active/view";
import ScooterZones from "views/pages/scooter/zones";
import ScooterParking from "views/pages/scooter/parking";
import DashboardScooter from "views/pages/scooter/dashboard";

import Language from "views/pages/Language";
import LanguageEdit from "views/pages/Language/edit";
import Translation from "views/pages/Translation";
import TranslationEdit from "views/pages/Translation/edit";
import Module from "views/pages/Module";
import ModuleEdit from "views/pages/Module/edit";

import AdminList from "views/pages/admin";
import AdminEdit from "views/pages/admin/view";

import ChargerStationsMap from "views/pages/chargers/stations/map";
import ChargerStationsList from "views/pages/chargers/stations";
import ChargerStationsItem from "views/pages/chargers/stations/single";
import ChargerStationsEdit from "views/pages/chargers/stations/edit";
import Chargers from "../views/pages/chargers/chargers";
import ChargersActiveRents from "../views/pages/chargers/rent-active";
import ChargersRents from "../views/pages/chargers/rent";
import ChargersPackages from "../views/pages/chargers/package/list";
import ChargersTariff from "../views/pages/chargers/tariff/list";

const RestrictedRoute = ({
                           component: Component,
                           isAuthenticated,
                           ...rest
                         }) => (
  <Route
    {...rest}
    render={props =>
      (isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location }
          }}
        />
      ))
    }
  />
);

// todo remove this when complete
// isAuthenticated = true;
// console.error("history, isAuthenticated, roles", history, isAuthenticated, roles);
const PublicRoutes = ({
                        history,
                        isAuthenticated,
                        roles
                      }) => (
  <ConnectedRouter history={history}>
    <div className="app">
      <Header/>
      <div className="app-body">
        {!isAuthenticated || <Sidebar history={history}/>}

        <div className="main">
          <Switch>
            <Route
              exact
              path="/"
              render={() => (isAuthenticated ? <Redirect to="/dashboard"/> : <Login/>)}
            />

            {/*
                <Route
                    exact
                    path="/"
                    render={() => (isAuthenticated ? RedirectToDashboard : <Login/>)}
                />
                */}

            <RestrictedRoute
              path="/dashboard"
              component={Dashboard}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/users"
              component={Users}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              path="/users/:id"
              component={UserProfile}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/wallet"
              component={Wallet}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/transactions"
              component={Transaction}
              isAuthenticated={isAuthenticated}
            />
            {/*
                    <RestrictedRoute
                        path="/wallet/:id"
                        component={WalletSignle}
                        isAuthenticated={isAuthenticated}
                    />
                    */}

            <RestrictedRoute
              exact={true}
              path="/bikes"
              component={Bikes}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/bike-scan-trigger"
              component={BikesScanTrigger}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/bike-trigger-history"
              component={BikesTriggerHistory}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/bikes/hotMap"
              component={BikesHotMap}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/bikes/police"
              component={BikesPolice}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/bikes/:bikeId"
              component={BikeSingle}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/bikes-history"
              component={BikesHistory}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/tariff"
              component={Tariff}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/package"
              component={Package}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/zoning"
              component={Zoning}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/festive-days"
              component={FestiveDays}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/tag"
              component={Tag}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/alerts"
              component={Alerts}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/fee"
              component={Fee}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/top-users"
              component={TopUsers}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/notificationTemplates"
              component={NotificationTemplates}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/phone-codes"
              component={PhoneCodes}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/news"
              component={News}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/stories/:id/:page"
              component={StoriesSingle}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/stories"
              component={Stories}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/static-pages"
              component={StaticPages}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/static-pages/edit/:id"
              component={StaticPagesEdit}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/static-pages/create"
              component={StaticPagesEdit}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/promo-codes"
              component={PromoCodes}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/reports"
              component={ReportsDailyRange}
              // isAuthenticated={true}
              isAuthenticated={isAuthenticated && roles
                .indexOf(ADMIN_ROLES.admin) > -1}
            />

            <RestrictedRoute
              path="/settings"
              component={Settings}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/trip-active"
              component={TripActive}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/locations"
              component={LocationsRouter}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/scooter/battery"
              component={ScootersBattery}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/scooter/battery-history"
              component={ScootersBatteryHistory}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/scooter/scooter"
              component={Scooters}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/scooter/scooter/hot-map"
              component={ScooterHotMap}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/scooter/scooter/history"
              component={ScooterHistory}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/scooter/scooter/:id"
              component={ScootersSingle}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/scooter/trip-active"
              component={ScooterTripActive}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              path="/scooter/trip-active/:id"
              component={ScooterTripActiveView}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              path="/scooter/zones"
              component={ScooterZones}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              path="/scooter/parking"
              component={ScooterParking}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              path="/dashboard-scooter"
              component={DashboardScooter}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              exact={true}
              path="/chargers/stations/map"
              component={ChargerStationsMap}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/chargers/stations/list"
              component={ChargerStationsList}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/chargers/stations/list/:id"
              component={ChargerStationsItem}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/chargers/stations/edit/:id"
              component={ChargerStationsEdit}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/chargers/history"
              component={Chargers}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/chargers/activeRents"
              component={ChargersActiveRents}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/chargers/rents"
              component={ChargersRents}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/chargers/packages"
              component={ChargersPackages}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              exact={true}
              path="/chargers/tariff"
              component={ChargersTariff}
              isAuthenticated={isAuthenticated}
            />

            <RestrictedRoute
              path="/translation/create"
              component={TranslationEdit}
              isAuthenticated={isAuthenticated}
              exact={true}
            />
            <RestrictedRoute
              path="/translation/edit/:id"
              component={TranslationEdit}
              isAuthenticated={isAuthenticated}
              exact={true}
            />
            <RestrictedRoute
              path="/translation"
              component={Translation}
              isAuthenticated={isAuthenticated}
              exact={true}
            />
            <RestrictedRoute
              path="/module/create"
              component={ModuleEdit}
              isAuthenticated={isAuthenticated}
              exact={true}
            />
            <RestrictedRoute
              path="/module/edit/:id"
              component={ModuleEdit}
              isAuthenticated={isAuthenticated}
              exact={true}
            />
            <RestrictedRoute
              path="/module"
              component={Module}
              isAuthenticated={isAuthenticated}
              exact={true}
            />

            <RestrictedRoute
              path="/language/create"
              component={LanguageEdit}
              isAuthenticated={isAuthenticated}
              exact={true}
            />
            <RestrictedRoute
              path="/language/edit/:id"
              component={LanguageEdit}
              isAuthenticated={isAuthenticated}
              exact={true}
            />
            <RestrictedRoute
              path="/language"
              component={Language}
              isAuthenticated={isAuthenticated}
              exact={true}
            />

            <RestrictedRoute
              path="/locations"
              component={LocationsRouter}
              isAuthenticated={isAuthenticated}
            />
            <RestrictedRoute
              path="/admin/edit/:id"
              component={AdminEdit}
              isAuthenticated={isAuthenticated}
              exact={true}
            />

            <RestrictedRoute
              path="/admin/create"
              component={AdminEdit}
              isAuthenticated={isAuthenticated}
              exact={true}
            />
            <RestrictedRoute
              path="/admin"
              component={AdminList}
              isAuthenticated={isAuthenticated}
              exact={true}
            />

            <Route
              exact
              path="/login"
              render={() => <Login/>}
            />

            {/* <Redirect to='/not-found'/> */}
            <Route exact path="/permission-error" component={PermissionError}/>
            <Route component={NotFound}/>
          </Switch>
        </div>

      </div>

      <ModalContainer/>
      {!isAuthenticated || <AlertWrapper/>}
      <ToastContainer
        closeOnClick={false}
        autoClose={3000}
        position="top-center"
        type={toast.TYPE.INFO}
      />
    </div>
  </ConnectedRouter>
);

PublicRoutes.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  roles: PropTypes.any
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  roles: state.auth.roles
});

export default connect(mapStateToProps)(PublicRoutes);



// WEBPACK FOOTER //
// ./src/routers/router.js